import webBiLogger from '@wix/web-bi-logger';
import schemaLogger from '@wix/bi-logger-rest-cc';

const factory = webBiLogger.factory();
const logger = schemaLogger(factory)();

export default logger;
